var $cb63ea5c57289e6c$exports = {};
$cb63ea5c57289e6c$exports = {
    "breadcrumbs": `Navigointilinkit`
};


export {$cb63ea5c57289e6c$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
